import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl,getUserToken } from './index';

const dispatchRequestChangePhoneNumber = changePhoneNumber => ({
    type: ActionTypes.REQUEST_CHANGE_PHONE_NUMBER,
    changePhoneNumber
})

const dispatchReceivedChangePhoneNumber= res => ({
    type: ActionTypes.RECEIVED_CHANGE_PHONE_NUMBER,
    res
})

const dispatchErrorChangePhoneNumber = err => ({
    type: ActionTypes.ERROR_CHANGE_PHONE_NUMBER,
    err
})

const dispatchClearChangePhoneNumber = () => ({
    type: ActionTypes.CLEAR_CHANGE_PHONE_NUMBER
})

export const clearChangePhoneNumber = () => dispatchClearChangePhoneNumber();

export const  changePhoneNumber = phoneNumber => dispatch =>{
        
    dispatch(dispatchRequestChangePhoneNumber(phoneNumber));

    const data = {
        new_phone: phoneNumber
    }

    getUserToken()
        .then( authKey => {
            const options = {
                method: 'post',
                url: `${baseUrl}/api/changephone`,
                data,
                headers: {
                    'Authorization': `Bearer ${authKey}`
                }
            }
            return axios(options)
                .then(({data}) => {
                    dispatch(dispatchReceivedChangePhoneNumber(data))
                })
        })
        .catch(({response}) => dispatch(dispatchErrorChangePhoneNumber(response)));   
}
